import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

import { VW_UNITS, ROLES } from '../constants'
import { TranslateService } from 'ng2-translate/ng2-translate';

/*
 * Raise the value exponentially
 * Takes an exponent argument that defaults to 1.
 * Usage:
 *   value | exponentialStrength:exponent
 * Example:
 *   {{ 2 |  exponentialStrength:10}}
 *   formats to: 1024
*/
@Pipe({
  name: 'dateFormat'
})
export class DateFormatPipe implements PipeTransform {
  transform(value: string): string {

    if (value != null) {

      let re = new RegExp('(19|20)[0-9][0-9]-(0[0-9]|1[0-2])-(0[1-9]|([12][0-9]|3[01]))T([01][0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]');
      if (re.test(value)) {

        let date: Date = new Date(value);
        let day: string;
        let dayIndex: number = date.getDate();
        let month: string;
        let monthIndex: number = date.getMonth() + 1;
        if (dayIndex < 10) {
          day = '0' + dayIndex.toString();
        } else {
          day = dayIndex.toString();
        }
        if (monthIndex < 10) {
          month = '0' + monthIndex.toString();
        } else {
          month = monthIndex.toString();
        }
        let year = date.getFullYear();

        value = day + "/" + month + "/" + year;

      } else if (value === 'sent') {
        value = 'Enviado';
      } else if (value === 'not-sent') {
        value = 'Não enviado';
      } else if (value === 'published') {
        value = 'Publicado';
      } else if (value === 'not-published') {
        value = 'Não publicado';
      } else if (value === 'new') {
        value = 'Novo';
      } else if (value === 'expired') {
        value = 'Expirado';
      } else if (value.toString() === 'false') {
        value = 'Não publicado';
      } else if (value.toString() === 'true') {
        value = 'Publicado';
      }

      return value;

    }
    else
      return '';
  }
}

@Pipe({
  name: 'timeFormat'
})
export class TimeFormatPipe implements PipeTransform {
  transform(value: string): string {

    let re = new RegExp('(19|20)[0-9][0-9]-(0[0-9]|1[0-2])-(0[1-9]|([12][0-9]|3[01]))T([01][0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]');
    if (re.test(value)) {

      let date: Date = new Date(value);
      let day: number = date.getDate();
      let hours: number = date.getHours();
      let minutes: number = date.getMinutes();
      let hour: string = hours.toString();
      let minute: string = minutes.toString();
      if (hours < 10) {
        hour = '0' + hours.toString();
      }
      if(minutes < 10){
        minute = '0' + minutes.toString();
      }
      value = hour + ':' + minute;
    }
    return value;
  }
}


@Pipe({
  name: 'ISOStringFormat'
})
export class ISOStringFormatPipe implements PipeTransform {
  transform(value: string): string {
    return new Date(value).toISOString();
  }
}

@Pipe({
  name: 'dateTimeFormat'
})
export class DateTimeFormatPipe implements PipeTransform {

  published: string;
  notPublished: string;
  expired: string;

  constructor(private translator: TranslateService){
    this.translateMessages();
  }

  translateMessages(){
    this.translator.get('pipe').subscribe((res) => {
      this.published = res['published'];
      this.notPublished = res['not-published'];
      this.expired = res['expired'];
    });
  }

  transform(value: string): string {

    if (value != null) {

      let re = new RegExp('(19|20)[0-9][0-9]-(0[0-9]|1[0-2])-(0[1-9]|([12][0-9]|3[01]))T([01][0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]');
      if (re.test(value)) {

        let date: Date = new Date(value);
        let day: string;
        let dayIndex: number = date.getDate();
        let month: string;
        let monthIndex: number = date.getMonth() + 1;
        if (dayIndex < 10) {
          day = '0' + dayIndex.toString();
        } else {
          day = dayIndex.toString();
        }
        if (monthIndex < 10) {
          month = '0' + monthIndex.toString();
        } else {
          month = monthIndex.toString();
        }
        let year = date.getFullYear();

        let hours: number = date.getHours();
        let minutes: number = date.getMinutes();
        let hour: string = hours.toString();
        let minute: string = minutes.toString();
        if (hours < 10) {
          hour = '0' + hours.toString();
        }
        if(minutes < 10){
          minute = '0' + minutes.toString();
        }

        value = day + "/" + month + "/" + year + " " + hour + ':' + minute;

      } else if (value.toString() == 'false') {
        value = this.notPublished;
      } else if (value.toString() == 'true') {
        value = this.published;
      }  else if (value === 'published') {
        value = this.published;
      } else if (value === 'not-published') {
        value = this.notPublished;
      } else if (value === 'expired') {
        value = this.expired;
      }

      return value;

    }
    else
      return '';
  }
}

@Pipe({
    name: 'unitFilter'
})
export class UnitFilterPipe implements PipeTransform {
    transform(items: any[], args: any[]): any {
      if(items == undefined){
        return;
      }
      else if(items.length > 0){
        if(items[0].unit != undefined){
          return items.filter(item => item.unit.indexOf(args) !== -1);
        }else{
          return items;
        }
      }
    }
}

@Pipe({
    name: 'clusterFilter'
})
export class ClusterFilterPipe implements PipeTransform {
    transform(items: any[], args: any[]): any {
      if(items == undefined){
        return;
      }
      else if(items.length > 0){
        if(items[0].cluster != undefined && args.toString() != 'Todas'){
          return items.filter(item => item.cluster.indexOf(args) !== -1);
        }else{
          return items;
        }
      }
    }
}

@Pipe({
  name: 'roleFormat'
})
export class RoleFormat implements PipeTransform{
  transform(value: any): string {

    for (const i in ROLES) {
      if (ROLES[i].VALUE === value) {
        value = ROLES[i].ROLE;
      }
    }
    return value;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/table/table.pipe.ts